import React from "react";

import { Dialog } from "@fronterahealth/frontera-ui-components";

interface DeleteTargetConfirmDialogProps {
  isOpen: boolean;
  setIsOpen: (value: boolean) => void;
  targetTitle: string;
  isDeleting?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export const DeleteTargetConfirmDialog: React.FC<DeleteTargetConfirmDialogProps> = ({
  isOpen,
  targetTitle,
  isDeleting = false,
  onConfirm,
  onCancel,
}) => {
  return (
    <Dialog
      size="xl"
      showCloseButton={false}
      title="Delete Target"
      open={isOpen}
      setOpen={() => {}}
      primaryButton={{
        text: isDeleting ? "Deleting..." : "Yes, Delete",
        onClick: onConfirm,
        type: "submit",
        buttonAction: "destructive",
        disabled: isDeleting,
      }}
      secondaryButton={{
        text: "No, Cancel",
        onClick: onCancel,
        disabled: isDeleting,
      }}
    >
      <div className="py-2 text-text-primary text-base">
        Are you sure you want to delete the target &quot;{targetTitle}&quot;? <br></br>
        This action cannot be undone.
      </div>
    </Dialog>
  );
};
